import { LocalStorageKey } from '@/utils/localStorage/localStorage.util.ts';
import React, { PropsWithChildren, useCallback, useMemo, useState } from 'react';

import { LayoutStates, PageContext, PageContextProps, PageDetailsModel } from './Page.context';

const DRAWER_RIGHT_WIDTH = 300;

const getLayoutStateCache = () => {
  const pageLayoutState = localStorage.getItem(LocalStorageKey.LAYOUT_STATE_PER_ROUTE);

  if (!pageLayoutState) {
    return;
  }
  return JSON.parse(pageLayoutState);
};
const setLayoutStateCache = (state: Record<string, LayoutStates>) => {
  localStorage.setItem(
    LocalStorageKey.LAYOUT_STATE_PER_ROUTE,
    JSON.stringify({
      ...getLayoutStateCache(),
      ...state,
    }),
  );
};
const PageContextProvider: React.FC<PropsWithChildren> = props => {
  const [pageDetails, setPageDetails] = useState<PageDetailsModel>({ titleId: 'processes' });
  const [layoutState, setLayoutState] = useState(
    () => getLayoutStateCache()?.[pageDetails.titleId] ?? LayoutStates.HIDDEN,
  );

  const currentLayoutState = useMemo(
    () => getLayoutStateCache()?.[pageDetails.titleId] ?? layoutState,
    [layoutState, pageDetails.titleId],
  );
  const rightSideBarWidth = useMemo(
    () => (layoutState === LayoutStates.VISIBLE ? DRAWER_RIGHT_WIDTH : 0),
    [layoutState],
  );

  const handleLayoutStateChange = useCallback(() => {
    if (layoutState === LayoutStates.VISIBLE) {
      setLayoutStateCache({ [pageDetails.titleId]: LayoutStates.HIDDEN });
      return setLayoutState(LayoutStates.HIDDEN);
    }
    setLayoutStateCache({ [pageDetails.titleId]: LayoutStates.VISIBLE });

    return setLayoutState(LayoutStates.VISIBLE);
  }, [layoutState, pageDetails.titleId]);

  const context: PageContextProps = useMemo(() => {
    return {
      handleLayoutStateChange,
      layoutState: currentLayoutState,
      pageDetails,
      rightSideBarWidth,
      setLayoutState,
      setPageDetails,
    };
  }, [handleLayoutStateChange, currentLayoutState, pageDetails, rightSideBarWidth]);

  return (
    <>
      <PageContext.Provider value={context}>{props.children}</PageContext.Provider>
    </>
  );
};

export default PageContextProvider;
